import { Component, ElementRef, Input, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';

import { ApiError, BaseFormList, MessageService, notCloseMessageOptions } from '../../../../../core';

import { NgForm } from '@angular/forms';
import { TabelaPreco } from '../../../../tabela-preco/tabela-preco';
import { TabelaPrecoCrudHttpService } from '../../../../tabela-preco/services/tabela-preco-crud-http.service';
import { TabelaPrecoFilterSearch } from '../../../../tabela-preco/filter/tabela-preco-filter-search';
import { isTabelaPrecoSituacaoInativa, tabelaPrecoAtiva } from '../../../../tabela-preco/tabela-preco-situacao';
import { CampanhaTabelaPreco } from '../campanha-tabela-preco';

@Component({
    selector: 'sgt-campanha-tabela-preco-form',
    templateUrl: './campanha-tabela-preco-form.component.html',
    styleUrls: ['./campanha-tabela-preco-form.component.less']
})
export class CampanhaTabelaPrecoFormComponent implements BaseFormList<CampanhaTabelaPreco>, OnInit {
    @Input() entities: CampanhaTabelaPreco[];
    @Input() canEdit = true;

    @ViewChild('form') form: NgForm;
    @ViewChildren('campanhaTabelaPrecoSelect') campanhaTabelaPrecoSelects: QueryList<ElementRef>;
    tabelasPrecos: TabelaPreco[] = [];

    constructor(private messageService: MessageService,
                private tabelaPrecoCrudHttpService: TabelaPrecoCrudHttpService) { }

    ngOnInit() {
        this.searchTabelasPrecos();
    }

     /** Pesquisa todas as tabelas de preços ativas */
     private searchTabelasPrecos() {
        this.tabelasPrecos = [];
        const tabelaPrecoFilter = new TabelaPrecoFilterSearch();
        tabelaPrecoFilter.situacao = tabelaPrecoAtiva.id;
        this.tabelaPrecoCrudHttpService.searchWithFilter(tabelaPrecoFilter, null, null, null, 2, 'asc')
            .subscribe(
                response => {
                    this.tabelasPrecos = response.data; // Tabelas ativas

                    // Verificando se a tabela atual existe no array de tabelas de preços ativas, pois pode ser uma tabela inativa
                    if (this.entities) {
                        this.entities?.forEach(entity => {
                            if (!this.tabelasPrecos.find(tabelaFilter => tabelaFilter.id === entity.idTabelaPreco)) {
                                this.tabelasPrecos.unshift(entity.tabelaPreco);
                            }
                        });
                    }
                },
                (error: ApiError) => this.messageService.error(error.message, 'Erro ao pesquisar as tabelas de preços', error)
            );
    }

    /** Verifica se a tabela de preço está inativa */
    isTabelaPrecoSituacaoInativa(entity: CampanhaTabelaPreco): boolean {
        if (!entity) {
            return;
        }
        return isTabelaPrecoSituacaoInativa(entity?.tabelaPreco?.situacao);
    }

    /** Ao alterar a tabela de preço */
    onChangeTabelaPreco(entity: CampanhaTabelaPreco, idTabelaPreco: number) {
        if (!entity) {
            return;
        }
        if (idTabelaPreco) {
            entity.idTabelaPreco = idTabelaPreco;
            entity.tabelaPreco = this.getTabelaPreco(idTabelaPreco);
        } else {
            this.clearTabelaPreco(entity);
        }
    }

    /** Obtem a tabela de preço */
    private getTabelaPreco(idTabelaPreco: number): TabelaPreco {
        if (!this.tabelasPrecos) {
            return null;
        }
        return this.tabelasPrecos.find(tabelaPrecoFilter => tabelaPrecoFilter.id === idTabelaPreco);
    }

    /** Remove a tabela de preço */
    private clearTabelaPreco(entity: CampanhaTabelaPreco) {
        if (!entity) {
            return;
        }
        entity.idTabelaPreco = null;
        entity.tabelaPreco = null;
    }

    insert() {
        if (!this.entities) {
            this.entities = [];
        }

        const entity = new CampanhaTabelaPreco();
        this.entities.push(entity);

        setTimeout(() => this.setFocusInsertTabelaPreco(), 200);
    }

    /** Seta o foco select da tabela de preço ao inserir uma nova tabela de preço */
    private setFocusInsertTabelaPreco() {
        jQuery(this.campanhaTabelaPrecoSelects?.last?.nativeElement).trigger('focus');
    }

    delete(index: number) {
        this.messageService.confirm('Deseja realmente excluir essa tabela de preço?').then(result => {
            if (result) {
                this.entities.splice(index, 1);
            }
        });
    }

    /** Verifica se as tabelas de preços da campanha estão válidos */
    isValid(): boolean {
        if (!this.canEdit) {
            return true;
        }

        for (let i = 0; i < this.entities.length; i++) {
            const entity = this.entities[i];

            if (!entity.idTabelaPreco) {
                this.messageService.warning('É necessário informar a tabela de preço ou excluir essa tabela de preço', 'Informação', notCloseMessageOptions);
                return false;
            }


            const count = this.entities.filter(entityFilter => entityFilter.idTabelaPreco && entityFilter.idTabelaPreco === entity.idTabelaPreco).length;
            if (count > 1) {
                this.messageService.warning(`A tabela de preço ${entity.tabelaPreco.codigoIntegracaoErp} - ${entity.tabelaPreco.nome} já está adicionada. Remova ou altere a tabela de preço duplicada`, 'Não é possível adicionar duas tabelas de preços iguais', notCloseMessageOptions);
                return false;
            }
        }

        // Form válido
        if (this.form.invalid) {
            this.messageService.warning('Informe corretamente todos os campos das tabelas de preço desta campanha', 'Atenção');
            return false;
        }

        return true;
    }

    /** Resolve as tabelas de preços presentes da campanha */
    resolve() { }
}
